import { SelectItem } from './common/SelectItem';

enum InstrumentType {
    CertificateofTransfer = 1,
    Deed,
    GeneralWarrantyDeed,
    MineralDeed,
    Plat,
    QuitClaimDeed,
    Sheriff,
    SpecialWarrantyDeed,
    TaxDeed,
    WarrantyDeed,
    Will,
}

export default InstrumentType;

export const convertInstrumentTypesToSelectList = (): SelectItem[] => {
    return Object.keys(InstrumentType)
        .filter((value: string | number) => isNaN(Number(value)) === false)
        .map(
            (key: string) =>
                new SelectItem(
                    parseInt(key, 10),
                    InstrumentType[parseInt(key, 10)]
                        .replace('of', ' of')
                        .replace(/([A-Z])/g, ' $1')
                        .trim()
                )
        );
};



// WEBPACK FOOTER //
// ./src/models/InstrumentType.ts